<div class="button" :class="color">{{ text }}</div>